import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  isLoggedIn: boolean;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  logout: () => void;
  syncFromAuthPresentCookie: () => void;
}

function readAuthPresentCookie() {
  if (typeof document === "undefined") {
    return false;
  }

  return document.cookie
    .split("; ")
    .some((part) => part === "auth_present=1" || part.startsWith("auth_present=1"));
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
      logout: () => set({ isLoggedIn: false }),
      syncFromAuthPresentCookie: () => {
        set({ isLoggedIn: readAuthPresentCookie() });
      },
    }),
    {
      name: "auth-storage",
      version: 2,
      partialize: (state) => ({ isLoggedIn: state.isLoggedIn }),
      migrate: () => ({ isLoggedIn: false }),
      onRehydrateStorage: () => (state) => {
        state?.syncFromAuthPresentCookie();
      },
    },
  ),
);
